import React, { useState } from 'react';
import search from '../../../../assets/image/search-status.svg';
import { useNavigate } from 'react-router-dom';

export default function SettingsSideBar({
	activeTab,
	setActiveTab,
	filteredSidebarData,
	setSearchTerm,
	searchTerm,
}) {
	const suburl = localStorage.getItem('suburl');
	const navigate = useNavigate();

	return (
		<div
			style={{
				backgroundColor: '#DADDEC',
				width: '220px',
				height: '100%',
				overflowX: 'none',
				position: 'fixed',
			}}
		>
			<div
				className="d-flex align-items-center border border-gray rounded-3 shadow-sm p-2 m-4"
				style={{ backgroundColor: '#EDEDF7' }}
			>
				<img
					src={search}
					alt="search-icon"
					width="20"
					height="20"
					className="rounded-circle me-2"
				/>
				<input
					type="search"
					placeholder="Search"
					style={{ border: '0' }}
					onChange={(e) => setSearchTerm(e.target.value)}
					className="flex-1 bg-transparent outline-none border-0 border-0 shadow-none text-gray-700 placeholder-gray-400"
				/>
			</div>
			<div
				className="p-4"
				style={{ width: '220px', height: 'calc(100% - 125px)', overflowX: 'auto' }}
			>
				{filteredSidebarData &&
					filteredSidebarData.map((section, index) => (
						<div
							key={index}
							className="mb-6"
						>
							<h2 className="fs-4 font-bold mb-2">{section.title}</h2>
							<ul
								className="space-y-2"
								style={{ listStyleType: 'none', paddingLeft: 0 }}
							>
								{section.items.map((item, idx) => (
									<li
										key={idx}
										className="nav-item p-2 rounded cursor-pointer fs-5"
										style={{
											color: item.label === activeTab ? '#fff' : '#555B67',
											backgroundColor: item.label === activeTab ? '#3B58FF' : '#DADDEC',
										}}
										onClick={() => {
											setActiveTab(item.label);
											navigate(
												`/user/${suburl}/settings/${item.label.replaceAll(' ', '-').toLowerCase()}`,
											);
										}}
									>
										{item.label}
									</li>
								))}
							</ul>
						</div>
					))}
			</div>
		</div>
	);
}
